import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppComponent } from '../app.component';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { bmxurl, getAccess } from 'src/globals';
import { users_returndata } from 'src/types/user_returndata';
import { booking_returndata } from 'src/types/booking_returndata';

@Component({
  selector: 'app-bookingstoacknowledge',
  templateUrl: './bookingstoacknowledge.component.html',
  styleUrls: ['./bookingstoacknowledge.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BookingstoacknowledgeComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  ListBookings: any[] = [];
  CreateUpdateResponse: any;
  httpResponse: any;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
  inProgress: boolean = false;

  constructor(
    private http: HttpClient,
    private appComp: AppComponent,
    private router: Router,
    private messageService: MessageService,
    private busyService: BusyService,
    private globalService: GlobalService) {
  }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse = (response as users_returndata);
      if (this.httpResponse.succeeded) {
        let user = this.httpResponse.data;

        if (getAccess("HOME", user)) {
          this.AccessAllowed = true;
          this.loadgrid();
        }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User, error:' + error.messages[0] });
    });
  }

  loadgrid() {
    this.busyService.busy();
    this.http.get(bmxurl + "acknowledgelist/" + this.VenueID).subscribe(response => {
      try {
        this.CreateUpdateResponse = (response as booking_returndata);
        this.ListBookings = this.CreateUpdateResponse.data;
      }
      catch (error) {
        this.messageService.add({ severity: 'error', summary: 'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!' });
      }
      finally {
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error getting bookings', detail: 'An error occurred getting Bookings' });
      this.busyService.idle();
    });
  }

  acknowledge(BID) {
    this.busyService.busy();

    this.http.get(bmxurl + "acknowledge/" + this.VenueID + "/" + BID).subscribe(response => {
      this.CreateUpdateResponse = response;
      if (this.CreateUpdateResponse.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Acknowledged', detail: 'Booking successfully acknowledged' });
        //loadgrid() takes its own spinner before this one is released, so it stays up
        //continuously until the refreshed list arrives.
        this.loadgrid();
        this.busyService.idle();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Not Acknowledged', detail: 'An error occurred acknowledging this Booking' });
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Acknowledged', detail: 'An error occurred acknowledging this Booking' });
      this.busyService.idle();
    });
  }

  viewBooking(ID) {
    this.router.navigate(["/partybooking", ID], { queryParams: { from: "newbookings" } });
  }

  goBack() {
    this.router.navigateByUrl("/ataglance");
  }
}
